import { useAtomValue } from "jotai";
import { themeStateAtom } from "src/services/ThemeService";

/**
 * The initials avatar is drawn by the server, so its background colour travels in the
 * url. It is the `--user-bg-color` token from _themes.scss, which differs per colour
 * mode, so it is read when rendering rather than once at import: at import time the
 * stylesheet may not be applied yet, and a module-level value never sees a mode switch.
 */
export function avatarColor(root: Element = document.documentElement): string {
    return getComputedStyle(root).getPropertyValue("--user-bg-color").replace("#", "").trim();
}

export function withAvatarColor(src: string, color: string): string {
    if (!color) return src;
    // The parameter belongs to the query, which ends where a #fragment starts.
    const hashAt = src.indexOf("#");
    const path = hashAt === -1 ? src : src.slice(0, hashAt);
    const fragment = hashAt === -1 ? "" : src.slice(hashAt);
    return path + (path.indexOf("?") === -1 ? "?" : "&") + "color=" + color + fragment;
}

const UserImg = (props: {src: string, className?: string, alt: string }) => {

    const {src, className, alt} = props;
    // Subscribing re-renders the avatar when the mode changes; the value itself comes
    // from the document, which ThemeService has already switched by then.
    useAtomValue(themeStateAtom);

    if( src === null || src === "" ){
        return null;
    }

    return <img className={ className } src={withAvatarColor(src, avatarColor())} alt={alt}/>

}
export default UserImg;
